var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',[_c('transition',{attrs:{"name":"fade-in-up"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }